import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

export default function LeadForm({ onSubmit, isSubmitting }) {
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', businessName: '', email: '', 
    phone: '', zipCode: '', bestTime: 'Morning 8-11am'
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="w-full max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-6 md:p-10">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <SafeIcon name="CheckCircle" className="w-8 h-8 text-emerald-500" />
        </div>
        <h2 className="text-3xl font-bold text-blue-900 mb-2">Analyzing Your Answers...</h2>
        <p className="text-gray-600">Where should we send your personalized coverage review?</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
            <input required type="text" name="firstName" onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 focus:border-blue-800 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
            <input required type="text" name="lastName" onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 outline-none" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Business Name *</label>
          <input required type="text" name="businessName" onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 outline-none" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
            <input required type="email" name="email" onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
            <input required type="tel" name="phone" placeholder="(XXX) XXX-XXXX" onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 outline-none" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">ZIP Code (CA) *</label>
            <input required type="text" name="zipCode" pattern="^9\d{4}$" title="Must be a valid 5-digit California ZIP code (starting with 9)" onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Best Time to Call</label>
            <select name="bestTime" onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-800 outline-none">
              <option>Morning 8-11am</option>
              <option>Afternoon 12-3pm</option>
              <option>Evening 4-7pm</option>
            </select>
          </div>
        </div>

        <button disabled={isSubmitting} type="submit"
          className="w-full mt-6 bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-4 rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2">
          {isSubmitting ? 'Processing...' : 'Get My Business Insurance Review'}
          {!isSubmitting && <SafeIcon name="ArrowRight" />}
        </button>

        <p className="text-xs text-center text-gray-500 mt-4 flex items-center justify-center gap-1">
          <SafeIcon name="Lock" className="w-3 h-3" />
          Your information is secure. We specialize in California small business insurance.
        </p>
      </form>
    </div>
  );
}